import { getCustomerUsers } from "./getCustomerUsers.util";

export const getAttendees = async (customerId) => {
    try {
        let users = await getCustomerUsers(customerId);

        console.log(`[Utilities] (getAttendees) Got customer users:`, users);

        if (users === null) {
            return [];
        }

        let attendees = users.filter((user) => user.ismsCommittee !== '');

        return attendees;
    } catch (error) {
        console.error('[Utilities] (getAttendees) Error fetching attendees:', error);
        return null;
    }
}